import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  class: "modal fade right",
  id: "share_modal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "ページをシェアする",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered modal-fullscreen-md-down",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  key: 0,
  class: "modal-body text-center"
}
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_share_buttons_business = _resolveComponent("share-buttons-business")!
  const _component_share_buttons = _resolveComponent("share-buttons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "modal-header text-center" }, [
          _createTextVNode(" シェアする "),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-mdb-dismiss": "modal",
            "aria-label": "Close"
          })
        ], -1)),
        (_ctx.node)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.node.name), 1),
              _createElementVNode("img", {
                src: _ctx.node.node_image,
                alt: _ctx.node.name,
                class: "rounded-1 mb-2 w-50 mx-auto"
              }, null, 8, _hoisted_6),
              _createElementVNode("p", {
                class: "text-start small",
                innerHTML: _ctx.sanitize(_ctx.node.description)
              }, null, 8, _hoisted_7),
              _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1)),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mb-2" }, "シェアする", -1)),
              (_ctx.node_type == 14)
                ? (_openBlock(), _createBlock(_component_share_buttons_business, {
                    key: 0,
                    node: _ctx.node
                  }, null, 8, ["node"]))
                : (_openBlock(), _createBlock(_component_share_buttons, {
                    key: 1,
                    node: _ctx.node
                  }, null, 8, ["node"]))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _renderSlot(_ctx.$slots, "footer"),
          _cache[2] || (_cache[2] = _createElementVNode("a", {
            href: "#",
            class: "btn btn-default",
            "data-mdb-dismiss": "modal"
          }, "閉じる", -1))
        ])
      ])
    ])
  ]))
}